import SmtpAccount from '../Models/SmtpAccount';
import DataGridRequest from './DataGridRequest';
export class SmtpAccountRequest extends DataGridRequest<SmtpAccount> {
    Url = 'connected_emails/api';
}

export class UsersWithoutSmtpRequest extends DataGridRequest<string> {
    Url = 'connected_emails/users_without_smtp';
}
